<template>
    <div class="container-fluid container-formulario">
        <div class="linha-1">
            <div class="d-lg-flex d-flex-column">
                <div>
                    <div class="d-flex">
                        <img :src="evento.urlLogoThumb" class="rounded evento" title="Grupo Negócios Públicos" v-if="evento.urlLogoThumb != null">
                    </div>
                    <div class="card painel">
                        <div class="card-body">
                            <h4 class="card-title d-flex titulo">Evento</h4>
                            <h4 class="card-title d-flex titulo2">{{ evento.nmEvento }}</h4>
                            <div class="card-text">
                                <strong class="d-inline-flex titulo">Data &amp; Local:</strong>
                                <div class="d-flex texto-1">{{ formatDay(evento.dtInicio) }} a {{ formatDay(evento.dtFim) }} de {{ formatMonth(evento.dtInicio) }} de {{ formatYear(evento.dtInicio) }}</div>
                                <div class="d-flex texto-2">{{ evento.dsLocal }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card painel-2">
                        <div class="card-body cardbody">
                            <nav class="btn btn-pagination d-flex justify-content-center">
                                <ul class="pagination pagination-lg btn-pgnt disabled" aria-disabled="true">
                                    <li :id="'paginacao_' + numero" :class="['page-item', numero == nrEtapa ? 'active' : 'page-link btn-link']" v-for="numero in [1, 2, 3, 4]" :key="numero">
                                        <span v-if="numero == nrEtapa" class="page-link">{{ numero }}</span>
                                        <span v-else>{{ numero }}</span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="flex-fill" v-if="evento.idEvento > 0 && !encerrado">
                    <Etapa_1 v-if="nrEtapa == 1" v-model:inscricao_value="inscricao" v-model:instituicao_value="instituicao" />
                    <Etapa_2 v-else-if="nrEtapa == 2" v-model:inscricao_value="inscricao" v-model:instituicao_value="instituicao" />
                    <Etapa_3 v-else-if="nrEtapa == 3" v-model:inscricao_value="inscricao" v-model:instituicao_value="instituicao" :idTipoEvento="evento.idTipoEvento" />
                    <Etapa_4 v-else-if="nrEtapa == 4" v-model:inscricao_value="inscricao" v-model:instituicao_value="instituicao" />
                </div>
                <div class="flex-fill" v-else>
                    <span>Evento Encerrado !</span>
                </div>
            </div>
            <div class="footer container-2 mt-4" v-if="evento.idEvento > 0 && !encerrado">
                <div class="col-sm-12 col-lg-12 ">
                    <button class="btn btn-danger float-end rounded" id="pp3" v-on:click="avancar" v-if="nrEtapa <= 3">PROXIMO PASSO</button>
                    <button class="btn btn-success float-end rounded" id="pp5" v-on:click="confirmar" v-if="nrEtapa == 4">CONFIRMAR</button>
                    <button class="btn btn-secondary rounded" id="v1" v-on:click="voltar" v-if="nrEtapa > 1">VOLTAR</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from "moment";
    import $ from "jquery";
    import axios from "axios";
    import Etapa_1 from "@/views/Inscricao/Etapas/Etapa_1.vue";
    import Etapa_2 from "@/views/Inscricao/Etapas/Etapa_2.vue";
    import Etapa_3 from "@/views/Inscricao/Etapas/Etapa_3.vue";
    import Etapa_4 from "@/views/Inscricao/Etapas/Etapa_4.vue";

    export default {
        name: "Inscricao",
        components: {
            Etapa_1,
            Etapa_2,
            Etapa_3,
            Etapa_4
        },
        data() {
            return {
                encerrado: false,
                nrEtapa: 1,
                evento: { idEvento: 0 },
                inscricao: {
                    qtdParticipantesOnline: 0,
                    idEvento: 0,
                    flMesmaPessoa: false,
                    idTipoInscricao: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    dtNascimentoResponsavel: null,
                    idDepartamentoResponsavel: 0,
                    idFuncaoResponsavel: 0,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    dtNascimentoFinanceiro: null,
                    idDepartamentoFinanceiro: 0,
                    idFuncaoFinanceiro: 0,
                    qtdParticipantes: 0,
                    flSalaoPrincipal: '',
                    idConvenio: null
                },
                instituicao: {
                    tpInstituicao: 'J',
                    nrCpfCnpj: '',
                    dsEmail: '',
                    nmNome: '',
                    dsCep: '',
                    nrTelefone: '',
                    nrCelular: '',
                    nmCidade: '',
                    nmUf: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    idConvenio: 0
                },
                requiredFields_1: ['nrCpfCnpj', 'nmNome', 'dsCep', 'dsEndereco', 'nrNumero', 'nmBairro', 'nmCidade', 'nmUf'],
                requiredFields_2: ['nmNomeResponsavel', 'dsEmailResponsavel', 'idDepartamentoResponsavel', 'idFuncaoResponsavel', 'nrCelularResponsavel', 'dtNascimentoResponsavel',
                    'nmNomeFinanceiro', 'dsEmailFinanceiro', 'idDepartamentoFinanceiro', 'idFuncaoFinanceiro', 'nrCelularFinanceiro', 'dtNascimentoFinanceiro'],
            };
        },
        methods: {
            formatDay(date) {
                return moment(date).format('DD');
            },
            formatMonth(date) {
                return moment(date).format('MMM').toUpperCase();
            },
            formatYear(date) {
                return moment(date).format('YYYY');
            },
            GetDadosEvento(_idEvento) {
                let $this = this;
                var idEvento = Math.floor(_idEvento / 1000);
                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Evento/GetDadosEventoExterno?idEvento=' + idEvento, {
                    headers: null,
                    notLoading: true
                }).then(response => {
                    $this.evento = response.data.data;
                    const date1 = moment($this.evento.dtFim);
                    const date2 = moment();
                    if (!date1.isSameOrAfter(date2)) {
                        $this.encerrado = true;
                    }
                }).catch(error => {
                    window.location.href = 'https://negociospublicos.com.br';
                });
            },
            avancar() {
                let $this = this;

                var validou = true;
                switch (this.nrEtapa) {
                    case 1:
                        var isValid = true;
                        for (const field of this.requiredFields_1) {
                            if (!this.instituicao[field]) {
                                isValid = false;
                                $this.$toast.show('alert', `O campo ${field} é obrigatório.`, true);
                                break;
                            }
                        }

                        if (this.instituicao.tpInstituicao == 'J' && isValid) {
                            isValid = this.validaCNPJ(this.instituicao.nrCpfCnpj);
                            if (!isValid) {
                                $this.$toast.show('alert', 'CNPJ informado é inválido !', true);
                            }
                        }
                        else if (this.instituicao.tpInstituicao == 'F' && isValid) {
                            isValid = this.validaCPF(this.instituicao.nrCpfCnpj);
                            if (!isValid) {
                                $this.$toast.show('alert', 'CPF informado é inválido !', true);
                            }

                            if (!this.validaEmail(this.instituicao.dsEmail) && isValid) {
                                $this.$toast.show('alert', 'Email da inscrição invalido.', true);
                                isValid = false;
                            }
                        }

                        if (!$this.$phoneValidator.validatePhoneCell($this.instituicao.nrTelefone, $this.instituicao.nrCelular)) {
                            $this.$toast.show('alert', 'Telefone ou celular é obrigatório e deve estar completo!', true);
                            isValid = false;
                        }

                        if (!isValid) {
                            validou = false;
                        }
                        break;
                    case 2:
                        var isValid2 = true;

                        if (this.inscricao.flMesmaPessoa) {
                            this.inscricao.nmNomeFinanceiro = this.inscricao.nmNomeResponsavel;
                            this.inscricao.dsEmailFinanceiro = this.inscricao.dsEmailResponsavel;
                            this.inscricao.idDepartamentoFinanceiro = this.inscricao.idDepartamentoResponsavel;
                            this.inscricao.idFuncaoFinanceiro = this.inscricao.idFuncaoResponsavel;
                            this.inscricao.nrTelefoneFinanceiro = this.inscricao.nrTelefoneResponsavel;
                            this.inscricao.nrCelularFinanceiro = this.inscricao.nrCelularResponsavel;
                            this.inscricao.dtNascimentoFinanceiro = this.inscricao.dtNascimentoResponsavel;
                        }

                        for (const field of this.requiredFields_2) {
                            if (!this.inscricao[field]) {
                                isValid2 = false;
                                $this.$toast.show('alert', `O campo ${field} é obrigatório.`, true);
                                break;
                            }
                        }

                        if (!this.validaEmail(this.inscricao.dsEmailResponsavel) && isValid2) {
                            $this.$toast.show('alert', 'Email do responsável invalido.', true);
                            isValid2 = false;
                        }

                        if (!this.validaEmail(this.inscricao.dsEmailFinanceiro) && isValid2) {
                            $this.$toast.show('alert', 'Email do responsável invalido.', true);
                            isValid2 = false;
                        }

                        if (!$this.$phoneValidator.validatePhoneCell(this.inscricao.nrTelefoneResponsavel, this.inscricao.nrCelularResponsavel)) {
                            $this.$toast.show('alert', 'Telefone ou celular do responsável é obrigatório e deve estar completo!', true);
                            isValid2 = false;
                        }

                        if (!$this.$phoneValidator.validatePhoneCell(this.inscricao.nrTelefoneFinanceiro, this.inscricao.nrCelularFinanceiro)) {
                            $this.$toast.show('alert', 'Telefone ou celular do financeiro é obrigatório e deve estar completo!', true);
                            isValid2 = false;
                        }

                        if (!isValid2) {
                            validou = false;
                        }
                        break;
                    case 3:
                        if (this.inscricao.qtdParticipantes <= 0 && this.inscricao.qtdParticipantesOnline <= 0) {
                            $this.$toast.show('alert', 'Quantidade deve ser maior que zero.', true);
                            validou = false;
                        }
                        break;
                    default:
                }
                if (validou) {
                    this.nrEtapa += 1;
                }
            },
            voltar() {
                this.nrEtapa -= 1;
            },
            confirmar() {
                let $this = this;

                $this.inscricao.idEvento = this.evento.idEvento;

                var request = { inscricao: $this.inscricao, instituicao: $this.instituicao };

                $this.inscricao.dsEmailResponsavel = $this.inscricao.dsEmailResponsavel.toLowerCase();
                $this.inscricao.dsEmailFinanceiro = $this.inscricao.dsEmailFinanceiro.toLowerCase();
                $this.instituicao.dsEmail = $this.instituicao.dsEmail.toLowerCase();

                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/PostExterno', request, { headers: null })
                    .then(function (response) {
                        window.location.href = process.env.VUE_APP_ROOT_EVENTOS_WEB + '/inscricaoparticipante?evento=' + Math.floor($this.evento.idEvento * 1000) + '&localizador=' + response.data.data;
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.$toast.show('alert', msg, true);
                    });
            },
            validaCNPJ(cnpj) {
                cnpj = cnpj.replace(/[^\d]+/g, '');

                if (cnpj.length !== 14) return false;

                if (/^(\d)\1+$/.test(cnpj)) return false;

                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;

                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                }

                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;

                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                }

                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                return resultado === parseInt(digitos.charAt(1));
            },
            validaCPF(cpf) {
                cpf = cpf.replace(/[^\d]+/g, '');

                if (cpf.length !== 11) return false;

                if (/^(\d)\1+$/.test(cpf)) return false;

                let soma = 0;
                for (let i = 0; i < 9; i++) {
                    soma += parseInt(cpf.charAt(i)) * (10 - i);
                }

                let resultado = 11 - (soma % 11);
                if (resultado === 10 || resultado === 11) resultado = 0;
                if (resultado !== parseInt(cpf.charAt(9))) return false;

                soma = 0;
                for (let i = 0; i < 10; i++) {
                    soma += parseInt(cpf.charAt(i)) * (11 - i);
                }

                resultado = 11 - (soma % 11);
                if (resultado === 10 || resultado === 11) resultado = 0;
                return resultado === parseInt(cpf.charAt(10));
            },
            validaEmail(email) {
                const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                return re.test(email);
            }
        },
        mounted() {
            var urlParams = new URLSearchParams(window.location.search);
            var idEvento = urlParams.get('evento');
            this.GetDadosEvento(idEvento);
        },
        updated() { },
        watch: {},
    };
</script>

<style scoped lang="scss">

    .container-formulario {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: calc(100vh - 0rem);
        height: calc(100vh - 0rem);
        background-color: #f8f8f8;
        padding: 0;
    }

    .painel {
        margin-top: 15px;
        margin-left: 30px;
        margin-right: 30px;
    }

    @media(min-width:520px) {
        .painel {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    @media(min-width:992px) {
        .painel {
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel {
            margin-left: 40px;
            width: 220px;
            margin-right: 10px;
        }
    }

    @media(min-width:1350px) {
        .painel {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    .conteudo {
        padding-left: 30px;
        padding-right: 40px;
    }

    @media(min-width:992px) {
        .conteudo {
            padding-left: 10px;
            margin-left: 30px;
        }
    }

    @media(min-width:1000px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 30px;
        }
    }

    .linha-1 {
        border: 1px solid #d3d3d3;
        background-color: #fff;
        margin-left: 2px;
        margin-right: 2px;
        min-height: calc(100vh);
        border-top: none;
        border-bottom: none;
    }

    @media (min-width: 430px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 32px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 550px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 52px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 100px;
            margin-right: 70px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 992px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: calc(10vw - 30px) !important;
            margin-right: calc(10vw - 30px) !important;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1200px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1400px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1500px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1800px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    .row > * {
        flex-shrink: 1;
    }

    .titulo {
        font-size: 14px;
        color: #bd2344;
        font-weight: 700
    }

    .titulo2 {
        font-size: 21px;
        line-height: 26px;
        color: #7a7a7a;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .texto-1 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
        margin-top: 5px;
    }

    .texto-2 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
    }

    .painel-2 {
        margin-top: 10px;
        margin-left: 30px;
        margin-right: 30px;
        padding: 16px;
        margin-bottom: 30px;
    }

    @media(min-width:520px) {
        .painel-2 {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    @media(min-width:992px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            margin-right: 10px;
            width: 220px;
        }
    }

    @media(min-width:1350px) {
        .painel-2 {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    .painel-3 {
        display: block;
    }

    .btn-pagination {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pagination {
            padding: 15px;
        }
    }

    .btn-pagination2 {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .card-painel {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
    }

    @media(min-width:630px) {
        .card-painel {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel {
            visibility: hidden;
            margin: 0;
            height: 0;
        }
    }


    .card-painel2 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel2 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel2 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel2 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel2 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 300px;
            display: block;
        }
    }

    .card-painel3 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel3 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel3 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel3 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel3 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 0;
            display: block;
        }
    }

    .active > .page-link,
    .page-link.active {
        margin-right: 15px !important;
        border-color: #ba2743 !important;
        color: #fff !important;
        background: #ba2743 !important;
        width: 37px !important;
        height: 39px !important;
        text-align: center !important;
        padding-top: 6px !important;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none !important;
        outline-style: none !important;
        z-index: 99 !important;
        padding-bottom: 10px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        font-size: 16px !important;
    }

    #paginacao_1 {
        margin-left: 15px;
    }

    .formularios {
        font-size: 22px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .dados-instituicao {
        font-size: 18px;
        color: #bd2344;
        font-weight: 500;
        border-bottom: 1px solid#ececec;
        padding-bottom: 13px;
    }

    .logo {
        height: 34px;
        margin-bottom: 0px;
        margin-left: 10px;
        margin-right: 10px;
        float: right;
    }

    @media(max-width:991px) {
        .logo {
            visibility: hidden;
            height: 0;
            width: 0;
        }
    }

    @media(min-width:992px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1200px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1400px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1537px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1800px) {
        .logo {
            margin-right: 20px;
            float: right;
            height: 34px;
        }
    }

    .evento {
        margin-top: 30px;
        height: 130px;
        width: 150px;
        margin-bottom: 0px;
        margin-right: 30px;
        margin-left: 30px;
    }

    @media(min-width:220px) {
        .evento {
            margin-top: 30px;
            height: 130px;
            width: 180px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:250px) {
        .evento {
            margin-top: 30px;
            height: 130px;
            width: 230px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:300px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 30px;
            margin-left: 30px;
        }
    }

    @media(min-width:520px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 50px;
        }
    }

    @media(min-width:700px) {
        .evento {
            margin-top: 30px;
            height: 280px;
            width: 650px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 50px;
        }
    }

    @media(min-width:925px) {
        .evento {
            margin-top: 30px;
            height: 280px;
            width: 850px;
            margin-bottom: 0px;
            margin-right: 50px;
            margin-left: 50px;
        }
    }

    @media(min-width:992px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 200px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1200px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 220px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1350px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 250px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    .descritivo {
        color: #777;
    }

    .informacao {
        border-color: #bbbbbb;
        margin-right: 1px;
        font-size: 14px;
    }

    .informacao2 {
        border-color: #bbbbbb;
        font-size: 14px;
    }

    .btn-danger {
        background-color: #bd2344;
        color: #fff;
        margin-top: 20px;
        margin-right: 30px;
        font-size: 15px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    .icon-inscricao {
        padding-right: 5px;
        font-size: 15px;
    }

    .btn-inscricao {
        background-color: #bd2344;
        color: #fff;
        font-size: 15px;
        font-weight: 400;
        padding: 3px 5px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    @media(min-width:992px) {
        .btn-inscricao {
            background-color: #bd2344;
            color: #fff;
            font-size: 15px;
            font-weight: 400;
            padding: 3px 5px;
            border-radius: 0;
            border: 2px solid #ececec;
        }
    }

    #salvar {
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
        margin-right: 20px;
    }

    .btn-success {
        background-color: #158000;
        color: #fff;
        margin-top: 20px;
        margin-right: 30px;
        font-size: 15px;
        padding: 10px 20px;
        font-weight: 500;
    }

    .footer {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
    }

    .footer-2 {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
        background-color: #f5f5f5;
    }

    .linha-2 {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-color: #ddd;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        display: block;
    }

    .font-1 {
        font-weight: 600;
        font-size: 14px;
        color: #4c4c4c;
    }

    .font-2 {
        font-weight: 600;
        font-size: 14px;
        color: #575757;
        padding-left: 10px;
    }

    .font-3 {
        font-size: 13px;
        margin-bottom: 10px;
        padding-left: 10px;
    }


    @media(min-width:992px) {
        .font-3 {
            font-size: 13px;
            margin-bottom: 3px;
            padding-left: 10px;
        }
    }

    .font-4 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-5 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-6 {
        font-weight: 400;
        color: #707070;
    }

    .font-7 {
        font-weight: 400;
        font-size: 16px;
        color: #4c4c4c;
        margin-top: 20px;
    }

    .input-checkbox {
        margin-top: 23px;
    }

    .btn-secondary {
        background-color: #d8d8d8;
        color: #575757;
        margin-top: 20px;
        margin-left: 30px;
        font-size: 15px;
        font-weight: 700;
        border: #bbbbbb;
        padding: 10px 20px;
        border-radius: 0;
    }

    .btn-secondary:hover {
        background-color: #d8d8d8;
        color: #575757;
    }

    .btn-link {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 37px;
        height: 39px;
        text-align: center;
        padding-top: 5px;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb !important;
        background: #f5f5f5;
        margin-right: 15px;
        padding-bottom: 10px;
        padding-left: 0;
        padding-right: 0;
        font-size: 16px;
    }

    .btn-link-4 {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 43px;
        height: 45px;
        text-align: center;
        padding: 5px 0;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
    }

    .cardbody {
        padding: 0;
    }

    .btn-pgnt {
        margin-bottom: 0;
    }

    .btn-pgnt2 {
        margin-bottom: 0;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .container-2 {
        margin-left: 0;
        margin-top: 0;
        margin-right: 0;
        width: 100% !important;
    }

    .quantidade-participantes {
        border-color: #7a7a7a;
        font-size: 40px;
        box-shadow: 1px solid !important;
        color: #555 !important;
        font-weight: 600;
    }

    @media(min-width:992px) {
        .quantidade-participantes {
            border-color: #a8a8a8;
            margin-left: 90px;
            font-size: 40px;
        }
    }


    .m-quantidade-participantes {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    #q-participantes {
        color: #4c4c4c;
        font-size: 20px;
        padding-left: 10px;
        font-weight: 600;
    }

    @media(min-width:992px) {
        #q-participantes {
            color: #4c4c4c;
            font-size: 20px;
            padding-left: 15px;
            font-weight: 600;
            margin-left: 95px;
        }
    }

    .paragrafo-1 {
        font-size: 16px;
        color: #96102d;
        padding-right: 40px;
        padding-left: 45px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-1 {
            font-size: 16px;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }

    .paragrafo-2 {
        font-size: 16px;
        color: #96102d;
        padding-left: 45px;
        padding-right: 40px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-2 {
            font-size: 16px;
            padding-right: 0;
            padding-left: 0;
        }
    }

    .corpo-col {
        padding-right: 0;
        margin-left: 10px;
    }

    @media(min-width:992px) {
        .corpo-col {
            margin-left: 30px;
            padding-right: 40px;
        }
    }

    .paragrafo-danger {
        font-size: 26px;
        text-align: center;
        color: #333;
        font-weight: 500;
    }
</style>